import { useEffect, useState } from "react";
import { group } from "../lib/icons";
import DataCard from "../reusable_components/DataCard";
import { title } from "../utils/style";
import { url } from "../utils/config";
import postData from "../custom_functions/postData";
import { Link } from "react-router-dom";
import BarChartComponent from "../reusable_components/BarChartComponent";
import LineChartComponent from "../reusable_components/LineChartComponent";
import resolve from '../assets/icons/issue_reopened.png';
import repair from '../assets/icons/repair_costs.png';
import recheck from '../assets/icons/recheck.png';
import ComparisonBarChart from "../reusable_components/ComparisonBarChart";
import formatNumberToUs from "../custom_functions/formatNumberToUs";
import Pagination from "../reusable_components/Pagination";
import moment from "moment";
import { FaPhoneAlt, FaRegFileAlt } from "react-icons/fa";
import { FaSquarePhone, FaFilePen } from "react-icons/fa6";
import { GiAutoRepair } from "react-icons/gi";
import { PiVanLight } from "react-icons/pi";

function Dashboard() {
    const [data, setData] = useState(null)
    const [showTopRepair, setShowTopRepair] = useState(false)
    const [currentPageAssignment, setCurrentPageAssignment] = useState(1);
    const [totalPageAssignment, setTotalPageAssignment] = useState(1);
    const [pageLimitAssignment, setPageLimitAssignment] = useState(10);

    const [currentPageWorkOrder, setCurrentPageWorkOrder] = useState(1);
    const [totalPageWorkOrder, setTotalPageWorkOrder] = useState(1);
    const [pageLimitWorkOrder, setPageLimitWorkOrder] = useState(10);

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPageAssignment) {
            setCurrentPageAssignment(page);
        }
    };
    const handlePageChangeWorkOrder = (page) => {
        if (page > 0 && page <= totalPageWorkOrder) {
            setCurrentPageWorkOrder(page);
        }
    };

    useEffect(() => {
        getDashData()
    }, [])

    // async function getPort() {
    //     try {
    //         const device = await navigator.bluetooth.requestDevice({acceptAllDevices: true});
    //         console.log('Device selected:', device);

    //         const btPort = device.gatt.connected ? device.gatt.server.device.gatt.connected : null;
    //         console.log('port',btPort)
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    const bookingData = [
        { bookingDate: '2024-11-09', availableTechnicians: 12 },
        { bookingDate: '2024-11-10', availableTechnicians: 8 },
        { bookingDate: '2024-11-11', availableTechnicians: 15 },
        { bookingDate: '2024-11-12', availableTechnicians: 9 },
        { bookingDate: '2024-11-13', availableTechnicians: 18 },
        { bookingDate: '2024-11-14', availableTechnicians: 22 },
        { bookingDate: '2024-11-15', availableTechnicians: 10 },
    ];

    async function getDashData() {
        try {
            const reqUrl = url + '/dashboard'

            postData(reqUrl, { date: new Date().toISOString().split('T')[0] }, (data) => { console.log(data); }, (data) => { setData(data); console.log(data) })

            if (data?.assignment?.length > 0) {
                setTotalPageAssignment(Math.ceil(data.assignment.length / pageLimitAssignment));
            }

            if (data?.workOrder?.length > 0) {
                setTotalPageWorkOrder(Math.ceil(data.workOrder.length / pageLimitWorkOrder));
            }

        } catch (error) {
            console.log(error)
        }
    }


    const paginatedAssignments = data?.assignment?.slice(
        (currentPageAssignment - 1) * pageLimitAssignment,
        currentPageAssignment * pageLimitAssignment
    );

    const paginatedWorkOrders = data?.workOrder?.slice(
        (currentPageWorkOrder - 1) * pageLimitWorkOrder,
        currentPageWorkOrder * pageLimitWorkOrder
    );

    useEffect(() => {
        if (data?.assignment) {
            setTotalPageAssignment(Math.ceil(data.assignment.length / pageLimitAssignment));
            setCurrentPageAssignment(1); // Reset to first page when limit changes
        }

        if (data?.workOrder) {
            setTotalPageWorkOrder(Math.ceil(data.workOrder.length / pageLimitWorkOrder));
            setCurrentPageWorkOrder(1); // Reset to first page when limit changes
        }
    }, [pageLimitAssignment, pageLimitWorkOrder, data]);


    return (
        <div className="p-4 bg-gray-100 mt-2 rounded-md">
            <div className={title}>Dashboard</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 py-4 w-full">
                <DataCard
                    title={'Total Phones'}
                    value={data?.phoneNumber[0]?.totalNumbers}
                    image={<FaSquarePhone />}
                />
                <DataCard
                    title={'Available Phones'}
                    value={data?.phoneNumber[0]?.availableNumbers}
                    image={<FaPhoneAlt />}
                />
                <DataCard
                    title={'Total Technicians'}
                    value={data?.technician[0]?.totalTechnicians}
                    image={<GiAutoRepair />}
                />
                <DataCard
                    title={'Total Appointments'}
                    value={data?.appointments[0]?.totalAppointments}
                    image={<FaRegFileAlt />}
                />
                <DataCard
                    title={'Pending Appointments'}
                    value={data?.appointments[0]?.pendingAppointments}
                    image={<FaFilePen />}
                />
                <DataCard
                    title={'Mobile Vans'}
                    value={data?.vans?.length}
                    image={<PiVanLight />}
                />
            </div>

            <div className=" bg-gray-100">
                <div className="grid grid-cols-2 py-6 gap-6">
                    <div>
                        <div className="bg-white rounded-lg shadow-md">
                            <h4 className="text-gray-600 text-md font-semibold pt-4 p-2 text-center">Availability Graph</h4>
                            <div className="">
                                {/* Placeholder for graph - can use chart.js or any other chart library */}
                                <BarChartComponent bookingData={bookingData} dataKey={'availableTechnicians'} />
                                {/* <LineChartComponent /> */}
                            </div>
                        </div>
                        {/* List of Assignments */}
                        <div className="bg-white p-4 rounded-lg shadow-md mt-4">
                            <div className="flex justify-between">
                                <h4 className="text-gray-600 text-md font-semibold mb-4">List of Assignments</h4>
                                <select
                                    id="region"
                                    name="region"
                                    className="pl-2 py-1 h-6 block border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-400 text-xs bg-gray-50"
                                    value={pageLimitAssignment}
                                    onChange={(e) => setPageLimitAssignment(e.target.value)}
                                >
                                    {[10, 20, 30].map((value, idx) => (
                                        <option key={idx} value={value}>
                                            {value}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="h-[300px] overflow-y-auto">
                                <table className="min-w-full bg-white text-sm">
                                    <thead className="bg-[#F3F4F6] sticky top-0 z-10">
                                        <tr className="bg-[#F3F4F6]">
                                            <th className="py-2">Phone Number</th>
                                            <th className="py-2">Technician ID</th>
                                            <th className="py-2">Customer Name/ID</th>
                                        </tr>
                                    </thead>
                                    <tbody className="w-full">
                                        {paginatedAssignments?.length > 0 &&
                                            paginatedAssignments.map((asgn, ind) => (
                                                <tr key={ind} className="hover:bg-blue-50  text-gray-600">
                                                    <td className="py-2 text-center">{asgn.technicianPhone}</td>
                                                    <td className="py-2 text-center">{asgn.technician_id}</td>
                                                    <td className="py-2 text-center">{asgn.user.firstName + ' ' + asgn.user.lastName}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>

                            <Pagination
                                currentPage={currentPageAssignment}
                                totalPages={totalPageAssignment}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                    <div>
                        {/* Date and Time Picker */}
                        {/* <div className=" bg-white p-4 rounded-lg shadow-md">
                            <h4 className="text-gray-600 text-sm font-semibold">Date and Time</h4>
                            <div className="flex gap-4 mt-2">
                            <input type="date" className="border p-2 rounded-md" />
                            <input type="time" className="border p-2 rounded-md" />
                            </div>
                        </div> */}
                        <div className=" bg-white rounded-lg shadow-md">
                            <h4 className="text-gray-600 text-md font-semibold pt-4 p-2 text-center">Weekly Appointments</h4>
                            <ComparisonBarChart />
                            {/* <LineChartComponent /> */}
                            {/* <BarChartComponent bookingData={data?.weeklyAppointmentFirst} dataKey={'totalBookings'} /> */}
                        </div>

                        <div className="flex flex-col gap-4 mt-4">
                            <div className="flex justify-between bg-white p-4 rounded-lg shadow-md">
                                <div className="flex gap-4 items-center">
                                    <div className="p-2 rounded-xl bg-customTwo">
                                        <img src={resolve} height={25} width={25} />
                                    </div>
                                    <h4 className="text-gray-600 text-sm">Time To Resolve Issues</h4>
                                </div>
                                <button className="text-blue-500 text-xs hover:underline">{'View Details >'}</button>
                            </div>
                            <div className=" bg-white p-4 rounded-lg shadow-md">
                                <div className="flex justify-between">
                                    <div className="flex gap-4 items-center">
                                        <div className="p-2 rounded-xl bg-customTwo">
                                            <img src={repair} height={25} width={25} />
                                        </div>
                                        <h4 className="text-gray-600 text-sm">Top Reasons For Repair</h4>
                                    </div>
                                    <button className="text-blue-500 text-xs hover:underline" onClick={() => setShowTopRepair(!showTopRepair)}>{'View Details >'}</button>
                                </div>
                                {
                                    showTopRepair && data?.topReasons?.length > 0 &&
                                    <div className="mt-2 text-sm text-gray-500 ml-4">
                                        {
                                            data.topReasons.map((reason, ind) =>
                                                <div key={ind} className="py-2">{reason.problem + '  -  ' + reason.count}</div>
                                            )
                                        }
                                    </div>
                                }
                            </div>
                            <div className="flex justify-between bg-white p-4 rounded-lg shadow-md">
                                <div className="flex gap-4 items-center">
                                    <div className="p-2 rounded-xl bg-customTwo">
                                        <img src={recheck} height={25} width={25} />
                                    </div>
                                    <h4 className="text-gray-600 text-sm">Work Orders Needing Approval</h4>
                                </div>
                                <button className="text-blue-500 text-xs hover:underline">
                                    <Link to='/billing'>{'View Details >'}</Link>
                                </button>
                            </div>
                            {/* Add more stats sections as needed */}
                        </div>

                    </div>
                </div>

                {/* Cost Control and Budget Tracking */}
                <div className="bg-white p-4 rounded-lg shadow-md">
                    <div className="flex justify-between">
                        <h4 className="text-gray-600 text-md font-semibold mb-4">Cost Control and Budget Adherence Tracking</h4>
                        <select
                            id="region"
                            name="region"
                            className="pl-2 py-1 h-6 block border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-400 text-xs bg-gray-50"
                            value={pageLimitWorkOrder}
                            onChange={(e) => setPageLimitWorkOrder(e.target.value)}
                        >
                            {[10, 20, 30].map((value, idx) => (
                                <option key={idx} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>

                    </div>
                    <div className="max-h-[300px] overflow-y-auto">

                        <table className="min-w-full bg-white">
                            <thead className="bg-[#F1F2F4] sticky top-0 z-10">
                                <tr>
                                    <th className="py-2">Repair ID</th>
                                    <th className="py-2">Date</th>
                                    <th className="py-2">Part Name/ID</th>
                                    <th className="py-2">Part Cost</th>
                                    <th className="py-2">Labor Cost</th>
                                    <th className="py-2">Total Repair Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedWorkOrders?.length > 0 &&
                                    paginatedWorkOrders.map((wo, ind) => (
                                        <tr key={ind} className="hover:bg-blue-50 text-gray-600">
                                            <td className="py-2 text-center">{'R00' + wo.work_estimation.booking_id}</td>
                                            <td className="py-2 text-center">{wo.date && moment(wo.date).format('MM-DD-YYYY')}</td>
                                            <td className="py-2 text-center">
                                                {JSON.parse(wo.work_estimation.materialList).data.map((ml, i) => (
                                                    <div key={i}>{ml.name}</div>
                                                ))}
                                            </td>
                                            <td className="py-2 text-center">${formatNumberToUs(wo.work_estimation.materialCost?.toFixed(2))}</td>
                                            <td className="py-2 text-center">${formatNumberToUs(wo.work_estimation.totalCost?.toFixed(2))}</td>
                                            <td className="py-2 text-center">
                                                ${formatNumberToUs((wo.work_estimation.materialCost + wo.work_estimation.totalCost)?.toFixed(2))}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>

                    </div>
                    <Pagination
                        currentPage={currentPageWorkOrder}
                        totalPages={totalPageWorkOrder}
                        onPageChange={handlePageChangeWorkOrder}
                    />
                </div>

            </div>
        </div>
    )
}
export default Dashboard;